module.exports = __webpack_public_path__ + "static/media/Logo.3ed1b876.svg";